import React from 'react';
import { useTranslation } from 'react-i18next';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ListSummary } from 'components/common/list-summary';
import type { ITransportMileageSummaryProps } from './types';

export const TransportMileageSummary: React.FC<ITransportMileageSummaryProps> = (props) => {
  const { summary } = props;
  const { t } = useTranslation();

  return (
    <ListSummary>
      {t('transport-mileage:total_mileage')}: {numberFormatter(summary.totalMileage)} km /{' '}
      {t('transport-mileage:total_mileage_cost')}: {numberFormatter(summary.totalMileageCost)} €
    </ListSummary>
  );
};
